<template>
    <div>
        <v-bottom-sheet v-model="dialog" v-if="showMobile" persistent hide-overlay>
            <v-sheet class="text-right">
                <v-btn
                    icon
                    color="primary"
                    class="btn-close"
                    @click="close">
                    <v-icon class="font-size-32 white rounded-circle"> mdi-close-circle</v-icon>
                </v-btn>
            <div
                class="d-flex flex-column justify-center align-center higlight-type-content"
            >
                <div
                    class="d-flex w-100 flex-column justify-center align-center position-relative pa-4"
                >
                    <div class="row w-100">
                        <div class="col-12 h-type-img w-100 d-flex flex-row justify-start align-center">
                            <img :src="markierImg" height="32" width="32" alt="icono de marcador" />
                            <div class="align-middle text-left line-height-100">
                                <p class="font-size-16 font-weight-bolder ma-0 text--primary">
                                    {{ $t('bookReading.notes') }}
                                </p>
                                <small class="font-size-12">{{ 'Mis notas' }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="w-100 d-flex flex-column justify-center align-center">
                        <v-row class="w-100">
                            <v-col cols="12" class="text-left">
                                <label for="" class="d-block text--primary mb-1">{{ $t('bookReading.notes_modal_msg') }}</label>
                                <v-textarea
                                    data-cy="noteModal-input-text"
                                    outlined
                                    rows="4"
                                    auto-grow
                                    class="border-radius-1 white font-size-16"
                                    hide-details
                                    name="txt_note"
                                    color="primary"
                                    v-model="noteContent"
                                    :placeholder="`${$t('bookReading.notes_modal_placeholder')}:`"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </div>
                    <v-row class="w-100 d-flex justify-center align-center">
                        <v-col>
                            <v-btn
                                data-cy="noteModal-save-button"
                                color="secondary"
                                class="px-16 py-5 bg-gradient-primary"
                                rounded
                                block
                                :loading="btnLoaded"
                                @click="saveNote"
                            >
                                {{ $t('save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </div>
            </v-sheet>
        </v-bottom-sheet>
        
        <v-dialog 
            v-model="dialog"
            v-if="!showMobile"
            persistent
            content-class="notes-modal"
            overlay-color="#514585FA"
            overlay-opacity="0.98"
            max-width="90vw"
            width="40%"
            >
            <div
                class="d-flex flex-column justify-center align-center higlight-type-content"
            >
                <div
                    class="d-flex w-100 flex-column justify-center align-center position-relative pa-4"
                >
                    <div class="row w-100">
                        <div class="col-12 h-type-img w-100 d-flex flex-row justify-content-between align-center">
                            <div class="row ma-0 align-items-center">
                                <img :src="markierImg" height="32" width="32" alt="icono de marcador" class="mr-1" />
                                <div class="align-middle text-left line-height-100">
                                    <p class="font-size-16 font-weight-bolder ma-0 text--primary">
                                        {{ $t('bookReading.notes') }}
                                    </p>
                                    <small class="font-size-12">{{ 'Mis notas' }}</small>
                                </div>
                            </div>
                            <v-btn
                                icon
                                color="primary"
                                class="btn-close"
                                @click="close">
                                <v-icon class="font-size-32 white rounded-circle"> mdi-close-circle</v-icon>
                            </v-btn>
                        </div>

                    </div>
                    <div class="w-100 d-flex flex-column justify-center align-center">
                        <v-row class="w-100">
                            <v-col cols="12" class="text-left">
                                <label for="" class="d-block text--primary mb-1">{{ $t('bookReading.notes_modal_msg') }}</label>
                                <v-textarea
                                    data-cy="noteModal-input-text"
                                    outlined
                                    rows="4"
                                    auto-grow
                                    class="border-radius-1 white font-size-16"
                                    hide-details
                                    name="txt_note"
                                    color="primary"
                                    v-model="noteContent"
                                    :placeholder="`${$t('bookReading.notes_modal_placeholder')}:`"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </div>
                    <v-row class="w-100 d-flex justify-center align-center">
                        <v-col>
                            <v-btn
                                data-cy="noteModal-save-button"
                                color="secondary"
                                class="px-16 py-5 bg-gradient-primary"
                                rounded
                                block
                                :loading="btnLoaded"
                                @click="saveNote"
                            >
                                {{ $t('save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </v-dialog>
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState } from 'vuex';

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    data() {
        return {
            btnLoaded: false,
            markierImg: require('@/assets/img/icons/new-reading/notes-purple.svg'),
            noteContent: '',
        }
    },
    methods: {
        close() {
            this.$emit('close-modal')
        },
        saveNote() {
            this.$emit('save-note')
        },
        resetVars() {
            this.noteContent = ''
            this.btnLoaded = false
        },
    },
    computed: {
    ...mapState({
        showMobile: (state) => state.isMobile,
      })
    },
}
</script>
<style lang="scss" scoped>
.h-type-img {
    z-index: 300;
}
.h-type-img img {
    height: 5vh;
    z-index: 10;
}
.higlight-type-content {
    border-radius: 26px;
    background: #fff;
}
.h-type {
    background: white;
    border: 1.5px solid #514773 !important;
}

.h-type:hover {
    background: rgb(216, 216, 216);
    cursor: pointer;
}

.h-type.active {
    border: 3px solid #514773 !important;
}

.btn-cls {
    top: 1vh;
    right: 1vh;
}
::v-deep .notes-modal{
    border-radius: 1em;
    padding-top: 0;
    .btn-close{
        left: 0;
        top: 0;
    }
}
</style>
